import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUSComponent {

  isDisplaydecision: boolean = false;
  isContinuosImprovement: boolean = false;
  isdiligence: boolean = false;
  iskt: boolean = false;
  ismerger: boolean = false;

  showDiv:boolean=false;
  

  html: string = '';

  aboutUsHeader="Our Capability";
 
  decisionHeader="S/4 HANA Transformation";
  continuousImprovementHeader="Continuous Improvement";
  diligenceHeader="Due Diligence or Audit";
  ktHeader="Efficient Knowledge Transfer";
  rollOut="Roll-out";

  decisionhtml = " If you are planning for an S/4 HANA transformation, you can take important business decisions like whether to go for a green-field or brown-field approach for the installation based on the volume of customization and its effective usage.";
  continuousimprovement = "For a continuous improvement plan, you can deduce which functional areas to prioritize first."
  diligence = "For a technical audit or due diligence, you may evaluate the system's configurations with regard to quality, change management and usage.";
  kt = "While ensuring an efficient Knowledge Transition, you can effectively communicate every detail about your SAP system with surgical precision.";
  merger = "In case of a Corporate reorganization, be it Mergers or acquisitions or a business carve-out, you may identify the most used configurations, customizations and processes and prioritize them for a roll-out.";

  constructor() { }
  mouseEnter(data: any) {
    if (data == "decision") {
      this.isDisplaydecision = true;
      this.isContinuosImprovement=false;
      this.isdiligence=false;
      this.iskt=false;
      this.ismerger=false;
      
      this.html = this.decisionhtml;
      this.showDiv=true;
      
    }
    else if (data == "CI") {
      this.showDiv=true;
      this.html = this.continuousimprovement;
      this.isDisplaydecision = false;
      this.isContinuosImprovement=true;
      this.isdiligence=false;
      this.iskt=false;
      this.ismerger=false;
    }
    else if (data == "diligence") {
      this.showDiv=true;
      this.html = this.diligence;
      this.isDisplaydecision = false;
      this.isContinuosImprovement=false;
      this.isdiligence=true;
      this.iskt=false;
      this.ismerger=false;
    }
    else if (data == "KT")
    {
      this.showDiv=true;
      this.html = this.kt;
      this.isDisplaydecision = false;
      this.isContinuosImprovement=false;
      this.isdiligence=false;
      this.iskt=true;
      this.ismerger=false;

    }
     
    else if (data == "merger")
    {
      this.showDiv=true;
      this.html = this.merger;
      this.isDisplaydecision = false;
      this.isContinuosImprovement=false;
      this.isdiligence=false;
      this.iskt=false;
      this.ismerger=true;
    }
     

  }

  mouseLeave(data: any) {
    this.isDisplaydecision = false;
    this.isContinuosImprovement=false;
    this.isdiligence=false;
    this.iskt=false;
    this.ismerger=false;
    if (data == "decision")
      this.showDiv = false;
    else if (data == "CI")
    this.showDiv = false
    else if (data == "diligence")
    this.showDiv = false
    else if (data == "KT")
    this.showDiv = false
    else if (data == "merger")
    this.showDiv = false
  }


}
